import { useRef } from "react";

export const useDragScroll = (externalRef) => {
  const internalRef = useRef(null);
  const scrollRef = externalRef || internalRef;

  const isDraggingRef = useRef(false);
  const dragStartX = useRef(0);
  const scrollLeftStart = useRef(0);

  const onMouseDown = (e) => {
    const el = scrollRef.current;
    if (!el) return;

    isDraggingRef.current = false;
    dragStartX.current = e.pageX - el.offsetLeft;
    scrollLeftStart.current = el.scrollLeft;

    const onMouseMove = (moveEvent) => {
      const x = moveEvent.pageX - el.offsetLeft;
      const walk = (x - dragStartX.current) * 1.5;

      if (Math.abs(walk) > 5) {
        isDraggingRef.current = true;
      }

      el.scrollLeft = scrollLeftStart.current - walk;
    };

    const onMouseUp = () => {
      el.removeEventListener("mousemove", onMouseMove);
      el.removeEventListener("mouseup", onMouseUp);
      el.removeEventListener("mouseleave", onMouseUp);
    };

    el.addEventListener("mousemove", onMouseMove);
    el.addEventListener("mouseup", onMouseUp);
    el.addEventListener("mouseleave", onMouseUp);
  };

  const wasDragging = () => isDraggingRef.current;

  return {
    scrollRef,
    onMouseDown,
    wasDragging,
  };
};
